import '@styles/components/appDisplayDesc.less';
interface advOne {
  imgUrl: string;
  title: string;
}
// 看模
const lookModel: advOne[] = [
  {
    imgUrl: 'fc88db803165be22',
    title: '快',
  },
  {
    imgUrl: '90768d5089653ecc',
    title: '全',
  },
  {
    imgUrl: '66305b303ee037f1',
    title: '大',
  },
  {
    imgUrl: '359ab89584e1309',
    title: '细',
  },
  {
    imgUrl: 'd2e02bf05b464370',
    title: '美',
  },
  {
    imgUrl: 'e84b84ae7f95da54',
    title: '准',
  },
];
// 组模
const combineModel: advOne[] = [
  {
    imgUrl: '3798e664d7fe5b9f.png',
    title: '模型组装',
  },
  {
    imgUrl: 'c2461f40db02d5bb.png',
    title: '构件插入',
  },
  {
    imgUrl: 'c2360138d77c8030.png',
    title: '材质替换',
  },
  {
    imgUrl: '5f5ada3746a8bdd0.png',
    title: '地球定位',
  },
];
// 转模
const transcoding: advOne[] = [
  {
    imgUrl: '27e85c18874fc4dd.jpg',
    title: '1',
  },
  {
    imgUrl: 'c278cf59f993e09f.jpg',
    title: '2',
  },
  {
    imgUrl: '849244050c2c4d6.jpg',
    title: '3',
  },
  {
    imgUrl: '1a1910071bc56c19.png',
    title: '4',
  },
];
// 秀模
const showModel: advOne[] = [
  {
    imgUrl: 'df8062a25ea5860c.png',
    title: '1',
  },
  {
    imgUrl: 'ee81e244953ac41f.png',
    title: '2',
  },
];

const AppDisplayDesc = () => {
  return (
    <div className={'app-display-desc'}>
      <div>
        <div className={'content-title'}>
          <p className={'text'}>“看模” 直观掌握 · 精准透视</p>
          <span className={'line'} />
        </div>
        <div className={'content-introduction'}>
          <div style={{ fontSize: '15px' }}>
            “看模王”无缝兼容多种主流BIM、CAD、 mGIS和3D模型格式，如Bentley (.dgn)、Autodesk
            (.rvt)、Catia (.3dxml)、CAD图纸
            (.dwg)，以及GIS、OBJ、GLTF等多种文件。通过高效的云端轻量化处理，模型能在几秒钟内完成发布，实现浏览器、桌面端、移动端
            秒级加载与浏览。同时，看模王还提供了全面细致的模型查看体验，包括完整的模型属性查询、多模型多图层集成展示、多视图切换、大
            规模模型及长线路项目的流畅浏览，以及精细BIM模型显示、多维度剖切分析、精准路线资料检索等功能。特有的楼层结构划分与路线导
            航功能，让您可以按需精细剖析建筑内部构造或道路规划。批注、校审、分享一气呵成，确保团队间的沟通无障碍，实现可视化、全关联
            的数字化交付流程。
          </div>
        </div>
        <div>
          {lookModel.map((item, index) => {
            return (
              <div>
                <img
                  style={{ width: '100%', display: 'block' }}
                  src={`https://ksj.com.cn/sitefiles/library/images/2024/5/${item.imgUrl}.png`}
                  alt=""
                />
                <div style={{ textAlign: 'center', marginBottom: '10px' }}>
                  <span style={{ color: '#D0000D', marginRight: '10px' }}>▲</span>看的{item.title}
                </div>
              </div>
            );
          })}
        </div>
      </div>
      <div>
        <div className={'content-title'}>
          <p className={'text'}>“组模” 灵活组合 · 创意无限</p>
          <span className={'line'} />
        </div>
        <div className={'content-introduction'}>
          <div style={{ fontSize: '15px' }}>
            “看模王”强大的组模功能，允许用户灵活组装不同来源、不同格式的模型，利用拖拽插入、放置等直观操作，在同一场景中让您轻松完成模型组装、构件插入、删除和替换、参考引用等，并能灵活调整模型的位置、朝向、材质、颜色等属性。此外，软件还支持地球坐标系设定与转换，助您构建包含地理信息的综合场景，从而适应各种复杂工程需求。
          </div>
        </div>
        <div>
          {combineModel.map((item, index) => {
            return (
              <div>
                <img
                  style={{ width: '100%', display: 'block' }}
                  src={`https://ksj.com.cn/sitefiles/library/images/2024/5/${item.imgUrl}`}
                  alt=""
                />
                <div style={{ textAlign: 'center', marginBottom: '10px' }}>
                  <span style={{ color: '#D0000D', marginRight: '10px' }}>▲</span>
                  {item.title}
                </div>
              </div>
            );
          })}
        </div>
      </div>
      <div>
        <div className={'content-title mt-30'}>
          <p className={'text'}>“转模” 格式自由 · 广泛适用</p>
          <span className={'line'} />
        </div>
        <img
          style={{ width: '60%' }}
          src={`https://ksj.com.cn/sitefiles/library/images/2024/5/444399fce64590c7.png`}
          alt=""
        />
        <div className={'content-introduction'}>
          <div style={{ fontSize: '15px' }}>
            突破格式壁垒，“看模王”支持广泛的BIM模型格式转换，不仅能够输出适用于GIS系统、游戏引擎如Unreal
            Engine的Obj、Gltf格式，还能提供业内先进的Bentley
            DGN文件格式导出服务，便于您在不同的工作环境和平台上无缝衔接BIM数据，确保模型数据在不同项目阶段和合作方之间顺畅流转。
          </div>
        </div>
        <div>
          {transcoding.map((item, index) => {
            return (
              <div>
                <img
                  style={{ width: '100%' }}
                  src={`https://ksj.com.cn/sitefiles/library/images/2024/6/${item.imgUrl}`}
                  alt=""
                />
              </div>
            );
          })}
        </div>
      </div>
      <img
        style={{ width: '100%', height: '40vw' }}
        src={`https://ksj.com.cn/sitefiles/library/images/2024/5/9c89e82310663542.jpeg`}
        alt=""
      />
      <div>
        <div className={'content-title mt-30'}>
          <p className={'text'}>“秀模” 生动演绎 · 酷炫展示</p>
          <span className={'line'} />
        </div>
        <div className={'content-introduction'}>
          <div style={{ fontSize: '15px' }}>
            借助“看模王”，您能够运用多样化的显示控制、渲染模式和场景特效工具，创作逼真的高精度仿真模型。内嵌的专业漫游工具助您定制个性化的漫游动画，与此同时，创新的项目看板和可视化展板——“抖模”功能，让项目方案以新颖酷炫的方式脱颖而出，支持图文、视频、模型的全关联互动式展示汇报。
          </div>
        </div>
        <div>
          {showModel.map((item, index) => {
            return (
              <div>
                <img
                  style={{ width: '100%' }}
                  src={`https://ksj.com.cn/sitefiles/library/images/2024/5/${item.imgUrl}`}
                  alt=""
                />
              </div>
            );
          })}
        </div>
      </div>

      <div style={{ background: '#F6F8FC', padding: '30px 0 10px' }}>
        <div className={'content-title'}>
          <p className={'text'}>产品优势 不凡性能 · 多元应用</p>
          <span className={'line'} />
          <div
            className={'advantageList'}
            style={{ padding: '20px 30px 0', fontSize: '13px', textAlign: 'left' }}
          >
            <div>
              <span>◆</span>
              全面兼容性：看模王能够处理众多行业标准格式，实现了行业内不同软件产出成果的统一管理和展示。
            </div>
            <div>
              <span>◆</span>
              便捷部署：无需安装插件，云端自动化处理，即刻发布使用。
            </div>
            <div>
              <span>◆</span>
              高效引擎：搭载BIM与GIS动态切片显示技术，保证高精度、高速度、大数据量下的流畅体验。
            </div>
            <div>
              <span>◆</span>
              精细化BIM+GIS融合：通过BIM内核与GIS动态融合，实现精细的三维场景交互展示，助力工程项目管理和决策。
            </div>
            <div>
              <span>◆</span>
              兼容DGN支持：原生DGN文件双向支持，模型整合处理后仍可编辑修改。
            </div>
            <div>
              <span>◆</span>
              强大编辑能力：不仅限于浏览，还可实现模型整合、局部编辑等操作。
            </div>
            <div>
              <span>◆</span>
              专业一体化：整合BIM+GIS+H5技术，实现项目全程数字化交付与汇报演示。
            </div>
            <div>
              <span>◆</span>
              灵活部署选项：支持单机、私有云、公有云等多种安装方式，无缝对接钉钉、微信及Web端应用。
            </div>
            <div>
              <span>◆</span>
              高度定制与扩展：提供丰富的API接口及定制开发服务，便于用户打造符合自身业务流程的管理系统。
            </div>
            <div>
              <span>◆</span> 国产自主可控：获得国产信创认证，安全可靠。
            </div>
            <div>
              <span>◆</span>
              灵活定价与使用模式：从免费的基础版本到付费的企业级解决方案，看模王提供多样化的购买选项，以满足不同规模企业和项目的预算及功能需求。
            </div>
          </div>
        </div>
      </div>
      <div>
        <div className={'content-title'}>
          <p className={'text'}>应用场景示例</p>
          <span className={'line'} />
        </div>
        <div className={'content-example'}>
          <div>日常BIM工作：</div>
          <p>
            <span>●</span>
            使用BIM建模软件建模，模型文件保存到看模王的工作空间，软件自动在云端转码并自动下载到本地。
          </p>
          <p>
            <span>●</span> 模型上传到“我的云盘”。
          </p>
          <p>
            <span>●</span> 使用桌面端或Web端或移动端随时随地浏览模型。
          </p>
          <p>
            <span>●</span>
            分享模型链接给其他人查看、浏览、审批。
          </p>
          <img
            style={{ width: '100%' }}
            src={`https://ksj.com.cn/sitefiles/library/images/2024/5/86292aa28f949167.png`}
            alt=""
          />
          <img
            style={{ width: '100%' }}
            src={`https://ksj.com.cn/sitefiles/library/images/2024/5/7859d3fe79959444.png`}
            alt=""
          />
          <div>基于“看模王”定制开发</div>
          <p>
            <span>●</span> Iframe方式直接和其他管理系统对接。
          </p>
          <p>
            <span>●</span> 对话框方式对接用户的应用软件。
          </p>
          <p>
            <span>●</span> 二次开发，调用API接口函数，构建用户自己的管理系统。
          </p>
          <img
            style={{ width: '100%' }}
            src={`https://ksj.com.cn/sitefiles/library/images/2024/5/3692045377c97645.png`}
            alt=""
          />
          <img
            style={{ width: '100%' }}
            src={`https://ksj.com.cn/sitefiles/library/images/2024/5/1beae1220c27a138.png`}
            alt=""
          />
          <img
            style={{ width: '100%' }}
            src={`https://ksj.com.cn/sitefiles/library/images/2024/5/2232bf72cf1792ca.png`}
            alt=""
          />
        </div>
      </div>
    </div>
  );
};

export default AppDisplayDesc;
